export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_05_RSeries.b6797d65.mp4";